import { createFileRoute } from '@tanstack/react-router';
import { BroadcastMetricsRouteView } from '@/pages/workspaces/broadcasts/broadcast/routing';

function BroadcastMetricsRoute() {
  const { broadcastId } = Route.useParams();
  return <BroadcastMetricsRouteView broadcastId={broadcastId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/metrics',
)({
  component: BroadcastMetricsRoute,
});
